import axios from "axios";
// axios.defaults.withCredentials = true;

// Ambil token dari cookie dan tambahkan ke setiap request
axios.interceptors.request.use((config) => {
  const token = getCookie("XSRF-TOKEN");
  if (token) {
    config.headers["X-XSRF-TOKEN"] = decodeURIComponent(token);
  }
  return config;
});

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

export const AppInitApi = {
  show: async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const token = sessionStorage.getItem("token");
      const userKey = sessionStorage.getItem("user_key");

      if (!apiUrl || !token || !userKey) {
        throw new Error(
          "API URL, token, or user key is not set in environment variables or session storage."
        );
      }
      const response = await axios.get(`${apiUrl}/appinit`, {
        headers: {
          "Access-Key": process.env.REACT_APP_ACCESS_KEY, // Use environment variable for access key
          Authorization: `Bearer ${token}`, // Use token from session storage
          "User-Key": userKey, // Use user key from session storage
          "Admin-Key": process.env.REACT_APP_ADMIN_KEY, // Use environment variable for admin key
          "Content-Type": "application/json",
        },
      });
      if (response.status !== 200) {
        throw new Error(
          "Failed to fetch customer with status: " + response.status
        );
      }
      if (response.data.error_code !== 200) {
        throw new Error("Failed to fetch customer: " + response.data.message);
      }
      return response.data;
    } catch (error) {
      console.error("Error fetching customer:", error);
      throw error;
    }
  },

  update: async ({ version }) => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const token = sessionStorage.getItem("token");
      const userKey = sessionStorage.getItem("user_key");

      if (!apiUrl || !token || !userKey) {
        throw new Error(
          "API URL, token, or user key is not set in environment variables or session storage."
        );
      }
      const reqBody = {};

      if (version !== undefined) {
        reqBody.version = version;
      }

      // 🛡️ Ambil CSRF cookie dulu (wajib jika pakai Sanctum)
      await axios.get(`${apiUrl.replace("/api", "")}/sanctum/csrf-cookie`);

      const response = await axios.put(`${apiUrl}/appinit`, reqBody, {
        headers: {
          "Access-Key": process.env.REACT_APP_ACCESS_KEY, // Use environment variable for access key
          Authorization: `Bearer ${token}`, // Use token from session storage
          "Admin-Key": process.env.REACT_APP_ADMIN_KEY, // Use environment variable for admin key
          "User-Key": userKey, // Use user key from session storage
          "Content-Type": "application/json",
        },
      });
      if (response.status !== 201) {
        throw new Error(
          "Failed to update customer with status: " + response.status
        );
      }
      return response.data;
    } catch (error) {
      console.error("Error updating customer:", error);
      throw error;
    }
  },
};
